import React from 'react';
import { ALIGNMENT_CSS_CLASS } from './constants';

export default (column, colIndex, { sortElement, filterElement }) => {
    const classes = ALIGNMENT_CSS_CLASS.RIGHT;
    return (
        <div className={classes}>
            {filterElement}
            {column.text}
            {sortElement}
        </div>
    );
};
